<template>
  <BaseDialog
    ref="baseDialog"
    modal-id="deleteGroupDialog"
    :title="$t('groups.deleteGroup')"
    :loading="loading"
    :confirm-text="$t('groups.delete')"
    confirm-variant="danger"
    @confirm="handleDelete"
  >
    <template #body>
      <p>
        {{$t('groups.confirmDelete')}} <strong>{{ groupName }}</strong>؟
      </p>
      <p class="text-danger">{{$t('groups.irreversibleAction')}}</p>
    </template>
  </BaseDialog>
</template>

<script setup>
import { ref, defineExpose, defineEmits, defineProps } from 'vue';
import BaseDialog from '@/components/common/BaseDialog.vue';

const emit = defineEmits(['delete']);

defineProps({
  groupName: {
    type: String,
    default: ''
  }
});

const baseDialog = ref(null);
const loading = ref(false);

const openDialog = () => {
  loading.value = false;
  baseDialog.value.openDialog();
};

const closeDialog = () => {
  baseDialog.value.closeDialog();
};

const handleDelete = async () => {
  loading.value = true;
  try {
    emit('delete');
    closeDialog();
  } finally {
    loading.value = false;
  }
};

defineExpose({ openDialog, closeDialog });
</script>
